import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { actualizarDatosParaMuiTable } from '../actions/TablaDetalleTotalCupoActions'
import TablaDetalleTotalCupoView from '../components/TablaDetalleTotalCupoView'
import { INTERVALO_ACTUALIZACION } from '../../../../../config/settings'
import UltimaActualizacionData from '../../../../Utils/containers/UltimaActualizacionDatos'

function TablaDetalleTotalCupo (props) {
  const { actualizarDatosParaMuiTable } = props
  const [ultimaActualizacion, setUltimaActualizacion] = useState(new Date())

  useEffect(() => {
    actualizarDatosParaMuiTable()

    const interval = setInterval(() => {
      setUltimaActualizacion(new Date())
      actualizarDatosParaMuiTable()
    }, INTERVALO_ACTUALIZACION)

    return () => {
      clearInterval(interval)
    }
  }, [actualizarDatosParaMuiTable, setUltimaActualizacion])

  return (
    <>
      <TablaDetalleTotalCupoView />
      <UltimaActualizacionData
        actualizar={actualizarDatosParaMuiTable}
        ultimaActualizacion={ultimaActualizacion}
        setUltimaActualizacion={setUltimaActualizacion}
      />
    </>
  )
}

const mapActionsToProps = {
  actualizarDatosParaMuiTable
}

const withRedux = connect(null, mapActionsToProps)
export default withRedux(TablaDetalleTotalCupo)
